import { createAction } from '@reduxjs/toolkit';

export const fetchTimezones = createAction('timezone/fetchTimezones');
